import { twMerge } from 'tailwind-merge';
import { Icon, Skeleton } from '@scale/scaleui';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

type SearchResultsListItemLoadingProps = {
  className?: string;
  icon: FontAwesomeIconProps['icon'];
};

export function SearchResultsListItemLoading({
  className,
  icon,
}: SearchResultsListItemLoadingProps) {
  return (
    <div className={twMerge('min-h-14 p-3 flex items-center', className)}>
      <Icon icon={icon} size="md" className="flex-shrink-0" />
      <div className="space-y-1">
        <Skeleton className="h-4 w-80 rounded" />
        <Skeleton className="h-3 w-56 rounded" />
      </div>
    </div>
  );
}
